import { Component, Input, OnInit } from '@angular/core';
import { ISchedulerSettings } from '../../interfaces/scheduler-settings.interface';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SchedulerSettingsService } from '../../services/scheduler-settings.service';

@Component({
    standalone: false,
    selector: 'app-stuck-treads-checker-settings-form',
    templateUrl: './stuck-treads-checker-settings-form.component.html',
    styleUrls: ['./stuck-treads-checker-settings-form.component.scss']
})
export class StuckTreadsCheckerSettingsFormComponent implements OnInit {
    _settings: ISchedulerSettings;

    formGroup: FormGroup;

    isProcessThreadsTTLCheckerActiveControl = new FormControl(false);

    minMaxProcessThreadTTLMin = 1;
    maxMaxProcessThreadTTLMin = 60;

    minProcessTreadsTTLResolutionSec = 10;
    maxProcessTreadsTTLResolutionSec = 300;

    maxProcessThreadTTLMinControl = new FormControl(1, [
        Validators.required,
        Validators.min(this.minMaxProcessThreadTTLMin),
        Validators.max(this.maxMaxProcessThreadTTLMin),
        Validators.pattern('^[0-9]*$')
    ]);

    processTreadsTTLResolutionSecControl = new FormControl(30, [
        Validators.required,
        Validators.min(this.minProcessTreadsTTLResolutionSec),
        Validators.max(this.maxProcessTreadsTTLResolutionSec),
        Validators.pattern('^[0-9]*$')
    ]);

    get settings(): ISchedulerSettings {
        return this._settings;
    }

    @Input()
    set settings(value: ISchedulerSettings) {
        this._settings = value;
        this.setFormData(this._settings);
    }

    constructor(
        protected readonly formBuilder: FormBuilder,
        protected readonly schedulerSettingsService: SchedulerSettingsService
    ) {
        this.formGroup = formBuilder.group({
            isProcessThreadsTTLCheckerActive: this.isProcessThreadsTTLCheckerActiveControl,
            maxProcessThreadTTLMin: this.maxProcessThreadTTLMinControl,
            processTreadsTTLResolutionSec: this.processTreadsTTLResolutionSecControl
        });
    }

    ngOnInit(): void {}

    setFormData(scheduleSettings: ISchedulerSettings) {
        if (!scheduleSettings) {
            return;
        }
        this.formGroup.patchValue(scheduleSettings);
    }
}
